import "./index.scss";

import { Box } from "@mui/material";
import { DataGridPremium, DataGridPremiumProps } from "@mui/x-data-grid-premium";
import { ReactComponent as DropdownIcon } from "assets/images/icons/dropdown.svg";
import { ReactComponent as DropdownUpIcon } from "assets/images/icons/dropdown-up.svg";
import Pagination, { PaginationProps } from "components/Pagination";
import { FC, memo } from "react";

interface TableProps extends DataGridPremiumProps {
  paginationProps?: PaginationProps;
  containerStyle?: any;
  slots: any;
  columns: any;
  headerHeight: any;
  pageSize: any;
  rowsPerPageOptions: any;
  pagination: true;
  page: any;
  onPageChange: (page: number) => void;
  disableVirtualization?: boolean;
}

const TableComponent: FC<TableProps> = (props) => {
  const { paginationProps, pagination, containerStyle = {}, ...restProps } = props;

  return (
    <Box className="table-container" style={containerStyle}>
      <DataGridPremium
        autoHeight={true}
        disableRowSelectionOnClick
        components={{
          ColumnSortedAscendingIcon: () => <DropdownUpIcon />,
          ColumnSortedDescendingIcon: () => <DropdownIcon />,
          Pagination: () => (pagination ? <Pagination {...paginationProps} /> : null),
        }}
        disableColumnMenu
        density="compact"
        {...restProps}
      />
    </Box>
  );
};

const Table = memo(TableComponent);
export default Table;
